module.exports = __webpack_public_path__ + "img/aplicativos.e299319b.svg";